import { ListselectionQuestionFunction } from '../../data/functions/list_selection_fn';
import { ISurveyQuestionItemDTO } from '../../major_explorer_interface';

export class SurveyQuestionListSelectionController {
  private mode: string;
  private item: ISurveyQuestionItemDTO;
  private delegateHandle: string = '';
  private isSecondPage: boolean = false;
  private validationCondition: { isValid: () => boolean };

  constructor(
    private $scope: ng.IScope,
    private listselectionQuestionFn: ListselectionQuestionFunction,
    private myIntakeModel: any
  ) {}

  $onInit() {
    this.isSecondPage = this.myIntakeModel.progression.isSecondListSelectionPage();
    this.delegateHandle = this.item._parent.nk + (this.isSecondPage ? 'second' : 'first');
    this.listselectionQuestionFn.initialize();
    this.validationCondition = {
      isValid: () => {
        return this.listselectionQuestionFn.validate(this.isSecondPage);
      }
    };
  }

  save = () => {
    return this.listselectionQuestionFn.item_onChange();
  };

  isListDisabled(interest: any) {
    return (
      this.listselectionQuestionFn.hasSelectedMaximumInterests(this.listselectionQuestionFn.models.questionList) &&
      !interest._selected
    );
  }

  isInterestSelected(interest: any): boolean {
    return interest._selected;
  }

  updateSelection(interest: any): void {
    if (!this.isListDisabled(interest)) {
      interest._selected = !interest._selected;
    }
  }
}

export class SurveyQuestionListSelectionComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/survey_question_listselection/survey_question_listselection.html';
  public controller: any = SurveyQuestionListSelectionController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    mode: '@',
    item: '='
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/survey_question_listselection/survey_question_listSelection_controller.ts